import React, { useEffect } from "react";
import { useCreation } from "ahooks";
import { TextLoading } from "../components/TextLoading/TextLoading";
import { BlankV2 } from "../Blank/BlankV2";
import { HtmlBloc } from "./HtmlBloc";
import { Button } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import isBlank from "@sedan-utils/is-blank";
import styles from "./Html.module.scss";
function Html(props) {
  var _props$createBlobUrl, _props$createBlobUrl2, _props$createBlobUrl3, _props$createBlobUrl4, _props$createBlobUrl7, _props$createBlobUrl8;
  var bloc = useCreation(function () {
    return new HtmlBloc();
  }, []);
  bloc.setProps(props);
  if (!((_props$createBlobUrl = props.createBlobUrl) !== null && _props$createBlobUrl !== void 0 && _props$createBlobUrl.streaming) && props.loading) {
    bloc.state.realWidth.value = false;
  }
  useEffect(function () {
    bloc.state.iframeLoadError.value = false;
    return function () {
      var _document$getElementB, _document$getElementB2;
      (_document$getElementB = document.getElementById(bloc.iframeId)) === null || _document$getElementB === void 0 || (_document$getElementB = _document$getElementB.contentDocument) === null || _document$getElementB === void 0 || (_document$getElementB2 = _document$getElementB.removeEventListener) === null || _document$getElementB2 === void 0 || _document$getElementB2.call(_document$getElementB, "click", bloc.clickIframe);
    };
  }, []);
  if (!((_props$createBlobUrl2 = props.createBlobUrl) !== null && _props$createBlobUrl2 !== void 0 && _props$createBlobUrl2.objectURL)) {
    return /*#__PURE__*/React.createElement("div", {
      className: styles.blankNode
    }, /*#__PURE__*/React.createElement(BlankV2, null));
  }
  // streaming 字段是来自custom api，websocket，频繁的返回进度条。应对这个情况新增加的字段
  if (!((_props$createBlobUrl3 = props.createBlobUrl) !== null && _props$createBlobUrl3 !== void 0 && _props$createBlobUrl3.streaming) && props.loading) return /*#__PURE__*/React.createElement(TextLoading, null);
  return /*#__PURE__*/React.createElement("div", {
    className: styles.content,
    style: bloc.state.previewStyle.value
  }, !isBlank(bloc.state.historyStack.value) && /*#__PURE__*/React.createElement(Button, {
    icon: /*#__PURE__*/React.createElement(ArrowLeftOutlined, null),
    onClick: function onClick() {
      return bloc.backHistory();
    },
    className: styles.backHistoryBtn,
    shape: "round"
  }), bloc.state.realWidth.value && bloc.state.iframeLoadError.value === false && /*#__PURE__*/React.createElement("iframe", {
    id: bloc.iframeId,
    title: props.uuid,
    className: styles.HtmlContainer,
    src: (_props$createBlobUrl4 = props.createBlobUrl) === null || _props$createBlobUrl4 === void 0 ? void 0 : _props$createBlobUrl4.objectURL,
    onLoad: function onLoad() {
      try {
        var iframe = document.getElementById(bloc.iframeId);
        var isCrossOrigin = bloc.checkIframeCrossOrigin(iframe);
        if (isCrossOrigin) return;
        bloc.checkIfIframeLoadedAndAddListener();
        var iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
        var body = iframeDocument.getElementsByTagName("body")[0];
        var bodyHeight = body.scrollHeight;
        var bodyWidth = body.scrollWidth;
        if (props.changeSizeByIframe) {
          var _props$createBlobUrl5;
          if (!((_props$createBlobUrl5 = props.createBlobUrl) !== null && _props$createBlobUrl5 !== void 0 && _props$createBlobUrl5.streaming)) {
            var _props$changeSizeByIf;
            (_props$changeSizeByIf = props.changeSizeByIframe) === null || _props$changeSizeByIf === void 0 || _props$changeSizeByIf.call(props, bodyWidth + 30, bodyHeight + 80);
          }
        } else {
          var _props$createBlobUrl6;
          if (!((_props$createBlobUrl6 = props.createBlobUrl) !== null && _props$createBlobUrl6 !== void 0 && _props$createBlobUrl6.streaming)) {
            bloc.state.previewStyle.value = {
              width: "100%",
              height: bodyHeight + 20
            };
          }
        }
      } catch (error) {
        bloc.state.iframeLoadError.value = true;
      }
    }
  }), bloc.state.iframeLoadError.value && /*#__PURE__*/React.createElement(IframeErrorMessage, {
    src: (_props$createBlobUrl7 = props.createBlobUrl) === null || _props$createBlobUrl7 === void 0 ? void 0 : _props$createBlobUrl7.objectURL
  }), !bloc.state.realWidth.value && /*#__PURE__*/React.createElement("iframe", {
    id: bloc.iframeId,
    title: props.uuid,
    className: styles.HtmlContainer,
    src: (_props$createBlobUrl8 = props.createBlobUrl) === null || _props$createBlobUrl8 === void 0 ? void 0 : _props$createBlobUrl8.objectURL,
    onLoad: function onLoad() {
      var _props$createBlobUrl9;
      var iframe = document.getElementById(bloc.iframeId);
      var isCrossOrigin = bloc.checkIframeCrossOrigin(iframe);
      if (isCrossOrigin) return;
      bloc.checkIfIframeLoadedAndAddListener();
      var body = iframe === null || iframe === void 0 ? void 0 : iframe.contentWindow.document.getElementsByTagName("body")[0];
      var bodyWidth = body.scrollWidth;
      if (props.changeSizeByIframe && !((_props$createBlobUrl9 = props.createBlobUrl) !== null && _props$createBlobUrl9 !== void 0 && _props$createBlobUrl9.streaming)) {
        var _props$changeSizeByIf2;
        (_props$changeSizeByIf2 = props.changeSizeByIframe) === null || _props$changeSizeByIf2 === void 0 || _props$changeSizeByIf2.call(props, bodyWidth + 30, 500);
      }
      bloc.state.realWidth.value = true;
    }
  }));
}
function IframeErrorMessage(_ref) {
  var src = _ref.src;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.errorMessage
  }, /*#__PURE__*/React.createElement("p", null, "The webpage failed to load, please click the link to open it in a new window."), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("a", {
    href: src,
    target: "_blank"
  }, src)));
}
export { Html };